import { Action } from 'redux';

import {
    SpaceContentsGetMonitoredViewStatus,
    SpaceContentsGetMonitoredViewStatusFailed,
    SpaceContentsGetMonitoredViewStatusSucceeded,
} from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IProcessedViewMonitoringStatusInfo } from '../types/AuthorConfiguredDCRTypes';

export interface SpaceContentsGetMonitoredViewStatusAction extends Action {
  viewLuids: string[];
}

export function spaceContentsGetMonitoredViewStatus(viewLuids: string[]): SpaceContentsGetMonitoredViewStatusAction {
  return {
    type: SpaceContentsGetMonitoredViewStatus,
    viewLuids
  };
}

export const isSpaceContentsGetMonitoredViewStatusAction = isActionFactory<SpaceContentsGetMonitoredViewStatusAction>(SpaceContentsGetMonitoredViewStatus);


export interface SpaceContentsGetMonitoredViewStatusSucceededAction extends Action {
  viewMonitoringStatusesInfo: IProcessedViewMonitoringStatusInfo[];
  viewLuidsRequested: string[];
}

export function spaceContentsGetMonitoredViewStatusSucceeded(viewMonitoringStatusesInfo: IProcessedViewMonitoringStatusInfo[], viewLuidsRequested: string[]): SpaceContentsGetMonitoredViewStatusSucceededAction {
  return {
    type: SpaceContentsGetMonitoredViewStatusSucceeded,
    viewMonitoringStatusesInfo,
    viewLuidsRequested
  };
}

export const isSpaceContentsGetMonitoredViewStatusSucceededAction = isActionFactory<SpaceContentsGetMonitoredViewStatusSucceededAction>(SpaceContentsGetMonitoredViewStatusSucceeded);

export interface SpaceContentsGetMonitoredViewStatusFailedAction extends Action {
  viewLuids: string[];
}

export function spaceContentsGetMonitoredViewStatusFailed(viewLuids: string[]): SpaceContentsGetMonitoredViewStatusFailedAction {
  return {
    type: SpaceContentsGetMonitoredViewStatusFailed,
    viewLuids
  };
}

export const isSpaceContentsGetMonitoredViewStatusFailedAction = isActionFactory<SpaceContentsGetMonitoredViewStatusFailedAction>(SpaceContentsGetMonitoredViewStatusFailed);
